import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.js";
import he from "he";
import HomeList from "./HomeList.js";
import LocationAvailability from "../../../components/Periscope/Dashboard/LocationAvailability";
import ItemAvailability from "../../../components/Periscope/Dashboard/ItemAvailability";
import MainHeader from "../../../components/Periscope/MainHeader";
import Bar from "../../../components/NivoCharts/Bar.js";
import SkeletonLoader from "../../../components/Periscope/SkeletonLoader.js";
import { ButtonIcon } from "../../../components/_commons/ButtonIcon.js";
import Popover from "../../../components/_commons/Popover.js";
import { DAYS, lS, MONTHS, printCurrency, trackEvent } from "../../../atlas-utils/index.js";
import { connect } from "react-redux";

const Home = ({ periscopeDashboard, currencySymbol, bizId }) => {
	return (
		<div className="periscope-container">
			<div className=" section-container-common-periscope periscope-dashboard ">
				<MainHeader classname={"header-periscope"} headerText="Periscope Dashboard" />
				<HomeList />
				<div className="dashboard-container-periscope">
					<div className="parent-container-peri ">
						<div className="first-div-peri">
							<GraphCards
								bizId={bizId}
								periscopeDashboardRedux={periscopeDashboard}
								currencySymbol={currencySymbol}
							/>
							<div className="location-item-data-peri">
								<div className="location-availability-periscope">
									<LocationAvailability /> <ItemAvailability />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default connect((store) => ({
	periscopeDashboard: store.periscopeDashboard,
	currencySymbol: store.login.loggedInbizDetail.currencySymbol,
	bizId: store.login.loggedInbizDetail.id
}))(Home);

const GraphCards = ({ periscopeDashboardRedux, currencySymbol, bizId }) => {
	const selectedCity = periscopeDashboardRedux?.selectedCity || "all";
	const loading = periscopeDashboardRedux?.downtimeMetrics?.loading;
	const error = periscopeDashboardRedux?.downtimeMetrics?.error;
	const dailyTrends = periscopeDashboardRedux?.downtimeMetrics?.data?.dailyTrends || [];
	const dailyTrendLabelKeys = periscopeDashboardRedux?.downtimeMetrics?.data?.dailyTrendLabelKeys || {};
	const currRevenueLost = periscopeDashboardRedux?.downtimeMetrics?.data?.currentPeriodTotalRevenueLost;
	const currDowntimeHours = periscopeDashboardRedux?.downtimeMetrics?.data?.currentPeriodTotalDowntimeHours;
	const prevRevenueLost = periscopeDashboardRedux?.downtimeMetrics?.data?.previousPeriodTotalRevenueLost;
	const prevDowntimeHours = periscopeDashboardRedux?.downtimeMetrics?.data?.previousPeriodTotalDowntimeHours;

	const localStorageData = lS.get("periscope") || { data: {} };
	if (!localStorageData.data) {
		localStorageData.data = {};
	}
	const existingStorageBizData = localStorageData?.data?.[bizId] || {};

	const getPercentageChange = (current, previous) => {
		if (previous === 0) {
			if (current === 0) {
				return { status: "+", percentage: 0 };
			}
			return { status: "+", percentage: 100 };
		}

		const diff = current - previous;
		const percentage = Math.abs((diff / previous) * 100);

		const status = diff >= 0 ? "+" : "-";

		return {
			status,
			percentage: Number(percentage.toFixed(2))
		};
	};

	const estimatedRevenueTab = useMemo(() => {
		return getPercentageChange(currRevenueLost, prevRevenueLost);
	}, [currRevenueLost, prevRevenueLost]);

	const downTimeTab = useMemo(() => {
		return getPercentageChange(currDowntimeHours, prevDowntimeHours);
	}, [currDowntimeHours, prevDowntimeHours]);

	const renderXaxisTick = (tick) => {
		const dateValue = dailyTrendLabelKeys?.[tick.value]?.date;
		const date = new Date(dateValue);
		const dayName = DAYS[date.getDay()];
		const day = date.getDate();
		const monthName = MONTHS[date.getMonth()];

		return (
			<g transform={`translate(${tick.x},${tick.y + 10})`}>
				<text
					textAnchor="middle"
					dominantBaseline="central"
					style={{ lineHeight: 22, fontSize: 14, fill: "#555" }}
				>
					<tspan x={0} dy={3} style={{ fill: "#363636" }}>
						{dayName}
					</tspan>
					<tspan x={0} dy={18} style={{ fill: "#8A8A8A" }}>{`${day} ${monthName}`}</tspan>
				</text>
			</g>
		);
	};
	const currency = he.unescape(currencySymbol);
	const history = useHistory();

	const goToSchedulesPage = () => {
		history.push("/timing-groups");
		trackEvent("create_schedule");
	};
	const tooltipInfo = (reason) => {
		return (
			<>
				<div className="reason-info">
					<div className="title">{reason}</div>
					<div>
						<div className="info-card">
							*For accurate data please ensure schedules are created on Atlas for all your locations.
						</div>
						<div className="link" onClick={goToSchedulesPage}>
							Go to Schedules
						</div>
					</div>
				</div>
			</>
		);
	};

	const renderPopover = (data) => {
		return <div className="pop-info">{data}</div>;
	};

	const [showInitialDowntimeTooltip, setShowInitialDowntimeTooltip] = useState(
		existingStorageBizData?.showInitialDowntimeTooltip !== 1
	);
	const [tooltipOutsideClick, setTooltipOutsideClick] = useState(false);
	const firstRender = useRef(true);

	useEffect(() => {
		if (firstRender.current) {
			firstRender.current = false;

			const shouldShow = existingStorageBizData?.showInitialDowntimeTooltip !== 1;
			if (shouldShow) {
				setShowInitialDowntimeTooltip(true);
			}
			const intervalId = setInterval(() => {
				setTooltipOutsideClick(true);
				clearInterval(intervalId);
			}, 1000);

			return () => clearInterval(intervalId);
		}
	}, []);

	const handleDismissDowntimeTooltip = () => {
		localStorageData.data[bizId] = {
			...existingStorageBizData,
			showInitialDowntimeTooltip: 1
		};
		lS.set("periscope", localStorageData);
		setShowInitialDowntimeTooltip(false);
	};
	return (
		<>
			<div className="periscope-dashboard-graph">
				{selectedCity !== "all" && (
					<div className="city-info">
						*City filter is currently not supported for Downtime and Estimated Lost Revenue.
					</div>
				)}
				<div className="home-graph-content">
					<div className={`graph-card ${loading || error ? "graph-loading" : ""}`}>
						<div className="text-content">
							<div className="heading">
								<div className="title">
									Total Downtime
									<div>
										<Popover
											data={tooltipInfo(
												"Indicates the duration the store was offline during its scheduled working hours, based on the store timings configured in Atlas. If no schedule is configured, the store is considered open 24/7."
											)}
											showOnHover={true}
											position={"down-left"}
											renderPopover={renderPopover}
											open={showInitialDowntimeTooltip}
											showOnClick={tooltipOutsideClick}
											onClose={handleDismissDowntimeTooltip}
										>
											<img
												src="../../../assets/periscope/tooltip-icon.svg"
												className="info-icon"
											/>
										</Popover>
									</div>
								</div>
								<div className="duration">Last 7 Days</div>
							</div>

							<div className="metric-values">
								{loading || error ? (
									<>
										<SkeletonLoader classname={`loading ${error ? "error-metric" : ""} `} />
										<SkeletonLoader classname={`loading-min ${error ? "error-metric" : ""} `} />
									</>
								) : (
									<>
										<div className="val">
											{!Number.isNaN(currDowntimeHours) &&
												currDowntimeHours !== null &&
												currDowntimeHours !== undefined && (
													<>
														<span> {currDowntimeHours}h </span>
													</>
												)}
										</div>
										<div className="rating-txt">
											{!Number.isNaN(downTimeTab?.percentage) &&
												downTimeTab?.percentage !== null &&
												downTimeTab?.percentage !== undefined && (
													<Popover
														showOnHover={true}
														renderPopover={() => (
															<div className="compare-info">
																<div className="compare-date">Prev 7D</div>
																<div className="compare-value">
																	{prevDowntimeHours}h
																</div>
															</div>
														)}
														position="middle-right"
														classes={`${downTimeTab?.percentage === 0 ? " zero-percent" : ""}`}
													>
														<>
															{downTimeTab?.percentage !== 0 && (
																<ButtonIcon
																	icon={downTimeTab?.status === "+" ? "up" : "down"}
																	classes="arrow"
																	color={
																		downTimeTab?.status === "+"
																			? "#D64949"
																			: "#0DA125"
																	}
																/>
															)}
															<span
																style={{
																	color:
																		downTimeTab?.percentage === 0
																			? "#808080"
																			: downTimeTab?.status === "+"
																				? "#D64949"
																				: "#0DA125",
																	marginLeft:
																		downTimeTab?.percentage == 0 ? "4px" : "0px"
																}}
															>
																{downTimeTab?.percentage}%
															</span>
														</>
													</Popover>
												)}
										</div>
									</>
								)}
							</div>
						</div>
						<ChartInteractionTracker chartName="downtime" loading={loading}>
							<Bar
								loading={loading}
								colors={["#FFE5E5"]}
								height={320}
								data={dailyTrends}
								padding={0.6}
								keys={["Total Downtime"]}
								groupMode={"stacked"}
								indexBy={"labelDate"}
								renderXaxisTick={(data) => renderXaxisTick(data)}
								renderCustomXaxis
								enableLegends={false}
								marginBottom={170}
								showAxisLeft
								axisLeftTickSize={0}
								units="h"
							/>
						</ChartInteractionTracker>
					</div>

					<div className={`graph-card ${loading || error ? "graph-loading" : ""}`}>
						<div className="text-content">
							<div className="heading">
								<div className="title">
									Estimated Lost Revenue
									<div>
										<Popover
											data={tooltipInfo(
												"Estimated value of sales lost during the time the store was offline, based on past revenue patterns."
											)}
											showOnHover={true}
											showOnClick
											position={"down-left"}
											renderPopover={renderPopover}
										>
											<img
												src="../../../assets/periscope/tooltip-icon.svg"
												className="info-icon"
											/>
										</Popover>
									</div>
								</div>
								<div className="duration">Last 7 Days</div>
							</div>
							<div className="metric-values">
								{loading || error ? (
									<>
										<SkeletonLoader classname={`loading ${error ? "error-metric" : ""} `} />
										<SkeletonLoader classname={`loading-min ${error ? "error-metric" : ""} `} />
									</>
								) : (
									<>
										<div className="val">
											{!Number.isNaN(currRevenueLost) &&
												currRevenueLost !== null &&
												currRevenueLost !== undefined && (
													<>
														<span>
															{currency}
															{currRevenueLost}
														</span>
													</>
												)}
										</div>
										<div className="rating-txt">
											{!Number.isNaN(estimatedRevenueTab?.percentage) &&
												estimatedRevenueTab?.percentage !== null &&
												estimatedRevenueTab?.percentage !== undefined && (
													<Popover
														showOnHover={true}
														renderPopover={() => (
															<div className="compare-info">
																<div className="compare-date">Prev 7D</div>
																<div className="compare-value">
																	{prevRevenueLost}
																	{printCurrency(currencySymbol)}
																</div>
															</div>
														)}
														position="middle-right"
														classes={`${estimatedRevenueTab?.percentage === 0 ? " zero-percent" : ""}`}
													>
														<>
															{estimatedRevenueTab?.percentage !== 0 && (
																<ButtonIcon
																	icon={
																		estimatedRevenueTab?.status === "+"
																			? "up"
																			: "down"
																	}
																	classes="arrow"
																	color={
																		estimatedRevenueTab?.percentage === 0
																			? "#808080"
																			: estimatedRevenueTab?.status === "+"
																				? "#D64949"
																				: "#0DA125"
																	}
																/>
															)}
															<span
																style={{
																	color:
																		estimatedRevenueTab?.percentage === 0
																			? "#808080"
																			: estimatedRevenueTab?.status === "+"
																				? "#D64949"
																				: "#0DA125",
																	marginLeft:
																		estimatedRevenueTab?.percentage == 0
																			? "4px"
																			: "0px"
																}}
															>
																{estimatedRevenueTab?.percentage}%
															</span>
														</>
													</Popover>
												)}
										</div>
									</>
								)}
							</div>
						</div>
						<ChartInteractionTracker loading={loading} chartName="lost_revenue">
							<Bar
								loading={loading}
								colors={["#FFE5E5"]}
								height={320}
								data={dailyTrends}
								padding={0.6}
								keys={["Estimated Lost Revenue"]}
								groupMode={"stacked"}
								indexBy={"labelDate"}
								renderXaxisTick={(data) => renderXaxisTick(data)}
								renderCustomXaxis
								enableLegends={false}
								marginBottom={170}
								units="k"
								currencySymbol={currencySymbol}
							/>
						</ChartInteractionTracker>
					</div>
				</div>
			</div>
		</>
	);
};

const ChartInteractionTracker = ({ children, chartName, loading }) => {
	const hasHoveredOnce = useRef(false);
	const handleMouseEnter = () => {
		if (!hasHoveredOnce.current && !loading) {
			hasHoveredOnce.current = true;
			trackEvent("periscope_home_trend_chart_hovered", { chart_type: chartName });
		}
	};

	return <div onMouseEnter={handleMouseEnter}>{children}</div>;
};
